"use client";

import { Instagram } from "lucide-react";
export default function Instagramfeed() {
  const isPluginActive = false;
  return;
}